/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$Container, $GraphicsBox, FC} from '@gongxigames/framework/core/fragments/BuilderY';
import {Signal} from '@gongxigames/framework/core';
import {COLOR_JURISDICTION_BG} from '@gongxigames/framework/slotV2/ui/ui-koala/CONSTANTS';

export type JurisdictionComponentProps = {
    rows: Signal<number>;
    panelHeight: Signal<number>;
};

export const $JurisdictionZoneMain: FC<JurisdictionComponentProps> = (props) => {
    return <$Container>
        <$GraphicsBox
            responsiveBoxSize
            boxColor={COLOR_JURISDICTION_BG}
            responsive={{
                box: {width: '100%', height: `${props.panelHeight.peek()}px`},
            }}
        />
    </$Container>;
};